<template>
  <div class="flex flex-col gap-2.5 lg:gap-3.75" :id="id">
    <h3 class="text-sm/[124%] lg:text-[17px]/[124%]">{{ label }}</h3>

    <div class="flex flex-col">
      <div
        v-for="option in options"
        :key="option.id"
        class="border-gray group flex cursor-pointer items-center gap-2.5 border-t py-3.75 text-sm/[124%] last:border-b lg:gap-3.75 lg:text-[17px]/[124%]"
        @click="model = option.value"
      >
        <input
          :id="option.id"
          type="radio"
          :name="id"
          :value="option.value"
          v-model="model"
          class="h-4 w-4 cursor-pointer appearance-none rounded-full border border-black bg-transparent transition-colors duration-400 group-hover:cursor-pointer checked:bg-black lg:h-5 lg:w-5 xl:h-6.5 xl:w-6.5"
          @click.stop
        />
        <label
          :for="option.id"
          class="w-full cursor-pointer group-hover:cursor-pointer"
          @click.prevent
        >
          {{ option.label }}
        </label>
      </div>
      <span v-if="error" class="animate-fade-in mt-2.5 text-xs text-red-600">
        {{ error }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  id: string
  label: string
  options: { id: string; value: string; label: string }[]
  error?: string
}

defineProps<Props>()
const model = defineModel<string>()
</script>
